// extracted by mini-css-extract-plugin
module.exports = {"video-lightweight":"VideoLightweight_video-lightweight__ANVsm"};